import { Suspense } from 'react';
import { Box } from '@givebutter/primitives/box';
import { Loader } from '@givebutter/primitives/loader';
import DonorSearch from 'assets/js/pages/contacts/single/donor-search';

const ContactIntegrations = () => {
    return (
        <Box className="p-8">
            <Suspense fallback={<Loader />}>
                <DonorSearch />
            </Suspense>
        </Box>
    );
};

export { ContactIntegrations };
